import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ShowHeaderButtons from 'src/javascripts/components/tables/checkboxes/ShowHeaderButtons';

// Uncheck one specific box on clck
export default function(tableId) {

  $('.checkbox-svg').click(function() {

    // Set currently selected records
    let recordIds = $('#' + tableId).data('record-ids');

    // Remove the selected record from the data array on the table
    let theRecord = $(this).closest('tr').attr('data-record-id');
    let index = recordIds.indexOf(theRecord);
    if (index > -1) {
      recordIds.splice(index, 1);
      $('#' + tableId).data('record-ids', recordIds);
    }

    // Un-check closest checkbox
    $(this).closest('td').find('.checkbox').prop('checked', false);

    // Remove the SVG
    $(this).remove();

    // Re-set number of checkboxes checked
    let numberChecked = $('#' + tableId).data('record-ids').length;
    $('#checkedCount').empty().append(numberChecked + ' selected');

    // Hide or show header depending on checkboxes selected
    if (numberChecked === 0) { 
      HideHeaderButtons(tableId); 
    } else {
      ShowHeaderButtons(tableId);
    }

  });

}
